module.exports = __webpack_public_path__ + "static/media/3DPPA42.dc7b004b.jpg";